import { render, staticRenderFns } from "./item-detail-navigator.vue?vue&type=template&id=43fee3db&"
import script from "./item-detail-navigator.vue?vue&type=script&lang=ts&"
export * from "./item-detail-navigator.vue?vue&type=script&lang=ts&"
import style0 from "./item-detail-navigator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports